import { render, staticRenderFns } from "./PromotionsTable.vue?vue&type=template&id=b78e4d00&"
import script from "./PromotionsTable.vue?vue&type=script&lang=js&"
export * from "./PromotionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports